import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useLocation } from 'react-router-dom';

import Auth0 from './Auth0';

export default function Login(props) {
    const { isAuthenticated, isLoading } = useAuth0();
    const location = useLocation();
    let urlToRedirect = undefined;
    if (location.state && location.state.from && location.state.from.pathname !== '/') {
        urlToRedirect = location.state.from.pathname;
    }
    console.log(urlToRedirect);

    return (
        <Auth0
            isLoading={isLoading}
            isAuthenticated={isAuthenticated}
            urlToRedirect={urlToRedirect}
        />
    );
}
